import React, { useEffect, useState } from "react";
import HireBox from "./HireBox";
import TimeSheet from "./TimeSheet";
// import RecommendedProfile from "../home/component/RecommendedProfile";
// import Filters from "./Filters";

import ApplicantsDetails from "./ApplicantsDetails";
import { useLocation, useParams } from "react-router-dom";
import { getData, postData } from "../../Service/ApiMethod";
import { APPLICANT, APPLICANTSV1, HIRE_LIST } from "../../Service/service";
import Applicants from "./Applicants";
import BackBar from "../home/BackBar";
import { useTranslation } from "react-i18next";
// import { Modal,Box } from '@mui/material'
import MultiRangeSlider from "multi-range-slider-react";
import { lang } from "../../lang";

const AppliedCandidates = ({ route }) => {

  var a = route?.param.id;
  console.log("iddD>>>", a);
  const [ln,setLn] = useState('en')
  const [active, setActive] = useState(true);
  const [hires, setHires] = useState(false);
  // const [filters, setFilters] = useState(false);
  const [timeSheet, setTimeSheet] = useState(false);
  const [detailPopup, setDetailPopup] = useState(false);
  const [applicant, setApplicant] = useState()
  const [updateOnUnlock, setUpdateOnUnlock] = useState(false)
  const [filterShow, setFilterShow] = useState(false)
  const [filteredApplicants, setFilteredApplicants] = useState()
  const [hire, setHire] = useState();

  const param = useParams();
  const vacancyID = param?.userid
  console.log('params data', param?.userid);


  const location = useLocation()
  const vacancyDetails = location?.state?.data

  console.log('vacancyDetails', vacancyDetails)

  const [minValue, set_minValue] = useState(0);
  const [maxValue, set_maxValue] = useState(0);
  const [minValuesal, set_minValuesal] = useState(0);
  const [maxValuesal, set_maxValuesal] = useState(0);
  const [maxValuedis, set_maxValuedis] = useState(0);
  const [minmetch,setMinmetch] =useState(0);
  const [maxmetch,setMaxmetch] =useState(0);



  // const compensation = ()=>{
  //   if (vacancyDetails?.compensation_details === "Monthly") {
  //     // vacancyDetails?.compensation_details = "M";
  //   } else if (vacancyDetails?.compensation_details === "Yearly") {
  //     // vacancyDetails?.compensation_details = "Y";
  //   } else if (vacancyDetails?.compensation_details === "Day") {
  //     // vacancyDetails?.compensation_details = "Daily";
  //   } else if (vacancyDetails?.compensation_details === "Weekly") {
  //     // vacancyDetails?.compensation_details = "W";
  //   } else{

  //   }
  // }


  const params = useParams()

  const vacancyId = params?.userid
  console.log('vacancy', vacancyId)

  const handleeClick = () => {
    console.log();
    let dataObj = {
      vacancy_id: vacancyId,
    };
    postData(dataObj, HIRE_LIST)
      .then((response) => response.json())
      .then((data) => {
        setHire(data?.data)
        console.log('Hired Candidates', data?.data);
      })
      .catch((err) => {
        console.log("Error in categories from Post Form", err);
        console.log(" code Error", err);
      });
  };



  useEffect(() => {
    if(localStorage.getItem("language") != null){
      setLn(localStorage.getItem("language"))
    }
    handleeClick();
  }, [])

  const handleClick = (e) => {
    let dataObj = {
      vacancy_id: vacancyID,
    };
    let valu = {
      vacancy_id: vacancyID,
      max_distance: parseInt(maxValuedis),
      min_experience: minValue,
      max_experience: maxValue,
      min_salary: minValuesal,
      max_salary:maxValuesal,
      min_match: minmetch,
      max_match: maxmetch,
      page_num: 1
    }
    console.log("valu",valu)
    postData(valu, APPLICANTSV1)
      .then((response) => response.json())
      .then((data) => {
        console.log('get candidates', data.data);
        setApplicant(data.data?.applicants_details)
        setFilterShow(false)
      })
      .catch((err) => {
        console.log("Error in categories from Post Form", err);
        console.log(" code Error", err);
        setFilterShow(false)
      });
  };
  useEffect(() => {
    handleClick();
    // compensation() 
  }, [updateOnUnlock]);

  console.log('applicants', applicant)
  useEffect(() => {
    handleClick();
    // compensation() 
  }, []);

  //   getData(experiance_url)

  // useEffect(()=>{
  //   getData(`${experiance_url}?id=${param.userid}`)
  // },[])

  const { t } = useTranslation();

  const handleInput = (e) => {
    set_minValue(e.minValue);
    set_maxValue(e.maxValue);
  };

  const handleInputsal = (e) => {
    set_minValuesal(e.minValue);
    set_maxValuesal(e.maxValue);
  };
  const handleInputsalmetch = (e) => {
    setMinmetch(e.minValue);
    setMaxmetch(e.maxValue);
  };

  // const [selectedOption, setSelectedOption] = useState(0);

  // const handleOptionChange = (e) => {
  //   setSelectedOption(e.target.value);
  // };




  return (
    <>
      <div className="wrapped-content-area pt-3">
        <BackBar title={t("Applicants & Hired")} />   

        {/* -----------------Vacancy box----------------- */}

        {/* <div> */}
        <div
          className="recommended-profile p-2"
          id={vacancyDetails?.id}
          name="clcikedd"
          style={{ }}
        >
          <div
            className="row"
          >
            <div className="col-md-1 col-12 px-0 mb-2 relative flex-center vaccancy-pic-area" >
              <div className="vaccancy-pic-area-profile">
              <img 
                src={vacancyDetails?.job_category_icon}
                alt=""
                className="profile-img"
              />
              </div>
              <div className="profile-match horizontal-center px-2">
                <img
                  src="../images/blue-eye.png"
                  className="mr-1"
                  alt=""
                />
                <span className="match-score">
                  {vacancyDetails?.no_of_applicants} {t('Applications')}
                </span>
              </div>
            </div>
            <div className="col-md-11 col-12 pr-0 mt-1"  >
              <h2 className="card-heding relative" >
                {vacancyDetails?.job_category_name}
                {/* <img
                          src="../images/pencilBlack.png"
                          alt=""
                          style={{ right: "20px", height: "12px" }}
                          className="addprofile"
                          // id={item?.id}
                          // onClick={()=>handleEdit(item)}
                        /> */}
                {/* <img
                          src="../images/err.jpg"
                          alt=""
                          style={{ height: "16px" }}
                          className="addprofile"
                          // id={item.id}
                          // onClick={(e) =>{ setDeletePopup(true); localStorage.setItem("vaccancy_id", e.target.id)}}
                        /> */}
              </h2>
              <p className="designation mt-2">
                {vacancyDetails?.urgent_vacancy ? (
                  <span>{t('Required')} {vacancyDetails?.job_category_name} {t('Immediately')}</span>
                ) : (
                  <span>{lang && Object.keys(lang).length > 0 ? lang[ln]?.new["No Required Immediately"]:""} </span>
                )}
              </p>
              <div className="row mt-1">

                {/* -----------------------old format---------------------------- */}
                {/* <div className="col-6 px-0">
                          <p className="card-subHeading">Total Experience</p>
                          <p className="card-subHeading">Work Location</p>
                          <p className="card-subHeading">Package</p>
                        </div>
                        <div className="col-6 px-0">
                          <p className="profile-info">
                            {vacancyDetails?.experience} {(vacancyDetails?.experience)>1 ? 'Years': 'Year'}
                          </p>
                          <p className="profile-info">
                            {(vacancyDetails?.work_location)}
                            </p>
                          <p className="profile-info">
                            {" "}
                            {vacancyDetails?.currency} {vacancyDetails?.compensation_amount} {vacancyDetails?.compensation_details}
                          </p>
                        </div> */}
                {/* --------------------------old format end------------------------ */}

                {/* -------------------------new format----------------------------- */}
                <div className="col-12 px-0">
                  <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    // border:'1px solid black'
                  }} >
                    <p className="card-subHeading">{lang && Object.keys(lang).length > 0 ? lang[ln]?.MyListsScreen["Total Experience"]:""}</p>
                    <p className="profile-info">
                      {vacancyDetails?.experience} {(vacancyDetails?.experience) > 1 ? lang && Object.keys(lang).length > 0 ? lang[ln]?.RecommendedComp['Years']:"" : lang && Object.keys(lang).length > 0 ? lang[ln]?.RecommendedComp['Year']:""}
                    </p>
                  </div>
                  <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    // border:'1px solid black'
                  }} >
                    <p className="card-subHeading worklocation">{t('Work Location')}</p>
                    <p className="profile-info">{(vacancyDetails?.work_location)}</p>
                  </div>
                  <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    // border:'1px solid black'
                  }} >
                    <p className="card-subHeading">{lang && Object.keys(lang).length > 0 ? lang[ln]?.MyListsScreen["Package"]:""}</p>
                    <p className="profile-info">
                      {vacancyDetails?.currency} {vacancyDetails?.compensation_amount} {lang && Object.keys(lang).length > 0 ? lang[ln]?.new[vacancyDetails?.compensation_details]:""}
                    </p>
                  </div>
                </div>
                {/* -------------------------new format end----------------------------- */}
                <div className="col-6 px-0">
                  <p className="horizontal-center">
                    {/* <img
                      src="./images/match-badge.png"
                      className="img-size18"
                      alt=""
                    />
                    <span className="ms-1 match-profile">99% Match</span> */}
                  </p>
                </div>
                <div className="col-6 px-0">
                  <p className="post-day text-right">
                    {t('Posted on')} {vacancyDetails?.posted_on} {t('ago')}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* </div> */}

        {/* ----------------------Vacancy box end ---------- */}

        <div className="col-lg-12 col-sm-12 px-0">
          <div className="applicant-hires space-between d-flex mb-2 sticky-top bg-theme px-3 align-items-center">
            <div className="d-flex ">
              <button
                onClick={() => {
                  setActive(true);
                  setHires(false);
                }}
                className={active ? "login-active" : "login"}
                style={{}}
              >
                {t('Applicants')}
              </button>
              <button
                onClick={() => {
                  setActive(false);
                  setHires(true);
                }}
                className={active ? "login" : "login-active"}
              >
                {t('Hires')}
              </button>
            </div>
            <div className="filter-img-container">
              <img className="filterr" style={{width:20}}
                src="../images/filter-icon.png "
                onClick={() => {
                  setFilterShow(!filterShow);
                }}
                alt=""
              />
            </div> 
          </div>
          {filterShow &&(  <div id="custom-modal" class="modal modal-filter">
        <div class="modal-content">
          
           
      
           <h5>{t("Filter candidate")}</h5> 
      
      
               <p>{t("Experience")} {minValue}{lang && Object.keys(lang).length > 0 ? lang[ln]?.RecommendedComp['Year']:""} - {maxValue}{lang && Object.keys(lang).length > 0 ? lang[ln]?.RecommendedComp['Years']:""}</p>
               <MultiRangeSlider
                 min={0}
                 max={100}
                 step={5}
                 ruler={true}
                 label={true}
                 minValue={minValue}
                 maxValue={maxValue}
                 preventWheel={false}
                 onInput={(e) => {
                   handleInput(e);
                 }}
               />
         
             <div style={{  }}> 
               <p>{lang && Object.keys(lang).length > 0 ? lang[ln]?.SearchEvents["Salary"]:""} {minValuesal}/{t("hrs")} - {maxValuesal}/{t("hrs")}</p>
               <MultiRangeSlider
                 min={0}
                 max={100}
                 step={5}
                 ruler={true}
                 label={true}
                 minValue={minValuesal}
                 maxValue={maxValuesal}
                 preventWheel={false}
                 onInput={(e) => {
                   handleInputsal(e);
                 }}
               />
             </div>
             <div style={{  }}> 
               <p>{lang && Object.keys(lang).length > 0 ? lang[ln]?.LastL["Matching Percentage"]:""} {minmetch}/{t("%")} - {maxmetch}/{t("%")}</p>
               <MultiRangeSlider
                 min={0}
                 max={100}
                 step={5}
                 ruler={true}
                 label={true}
                 minValue={minmetch}
                 maxValue={maxmetch}
                 preventWheel={false}
                 onInput={(e) => {
                   handleInputsalmetch(e);
                 }}
               />
             </div>
             <div style={{}}>
               <label style={{ marginRight: '10px' }}>{lang && Object.keys(lang).length > 0 ? lang[ln]?.LastL["Distance"]:""}: {maxValuedis}/{t("KM")}</label>
               <input
                 type="range"
                 name="min"
                 className="distancerange"
                 min="0"
                 max="300" 
                 value={maxValuedis}
                 onChange={(e) => set_maxValuedis(e.target.value)}
               />
             </div>
             {/* <div style={{  }}>
               <label>{t("Type of employment contract")}</label><br></br>
               <select value={selectedOption} onChange={handleOptionChange} className='candidate-select'>
                 <option value="1">{t("Full Time")}</option>
                 <option value="2">{t("Part Time")}</option>
                 <option value="3">{t("Contract")}</option>
               </select>
             </div> */}
             <div className='text-center' style={{display:"flex",justifyContent: "space-between"}}>
             <button className=' btn btn-primary' style={{marginTop:10}} onClick={() => {
            setFilterShow(false);
             }}>{t("Cancel")}</button>
             <button className=' btn btn-primary' style={{marginTop:10}} onClick={() => {
               let val = ''
               handleClick(val)
             }}>{t("Submit")}</button>
             </div>
             </div>
             </div>
        )
        //    <Modal
        //    open={filterShow}
        //    onClose={filterShow}
        //    aria-labelledby="modal-title"
        //    aria-describedby="modal-description"
        //  >
          
        //     {/* <Filters
        //       applicants_details={hires ? hire : applicant}
        //       filterShow={filterShow} setFilterShow={setFilterShow}
        //       setFilteredApplicants={setFilteredApplicants} /> */}








        //       </Modal>
          }
          {/* <hr className="line mt-n2 mb-3" /> */}

          {/* <VaccancyBox />  */}
          <div className="row applicants-hired"> 
            {hires ? (
              <HireBox
                hire={hire} timesheetPopup={setTimeSheet}
              />
            ) : (
              <Applicants applicants_details={(filteredApplicants || applicant)} setUpdateOnUnlock={setUpdateOnUnlock} updateOnUnlock={updateOnUnlock} />
            )}
            {timeSheet ? (
              <TimeSheet
                timesheetPopup={setTimeSheet}
              />
            ) : null}
          </div>
        </div>

        {/* {filters ? (
          <Filters
            closePopup={() => {
              setFilters(false);
            }}
          />
        ) : null} */}
        {detailPopup ? (
          <ApplicantsDetails closePopup={() => setDetailPopup(false)} />
        ) : null}
      </div>
    </>
  );
};

export default AppliedCandidates;
